<template>
  <v-app>
    <v-overlay v-model="overlay" class="align-center justify-center">
      <v-progress-circular
        indeterminate
        color="amber"
        :size="70"
      ></v-progress-circular>
    </v-overlay>

    <div>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ props }">
          <v-btn color="primary" class="mb-4" dark v-bind="props">
            Инструкция
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Импорт данных из Е-услуг</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col>Внимание! выгружаются только заявления со статусами Новое/Направлен на вступительные испытания/Очередник<br/>
              Требуется подтверждение данных заявления/Требуется прикрепление документов/Требуются оригиналы документов/Распределён/Направлен в ПОО
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                1. В разделе Заявления->заявления в ПОО<br />
                нужно выбрать фильтр "учебный год" : 2023-2024,<br />
                кнопка применить, чтобы мы увидели список заявлений в таблице<br />
                нопка "экспорт" ->все столбцы. Будет сохранен xls файл с
                персональными данными абитуриентов
              </v-col>
              <v-col>
                <img
                  :src="
                    $model.wwwroot +
                    '/blocks/manage_groups/admission/img/1.png'
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                2.В разделе Заявления->конкурсные списки<br />
                необходимо выбрать поля<br /><hr />
                Предпочитаемая специальность<br/>
                Форма обучения<br/>
                Основа обучения<br/>
                База приема<br/>
                Конкурс<br/>
                ФИО абитуриента<br/>
                Приоритет специальности<br/>
                Номер<br/>
                Ср. балл аттестата<br/>
                Дата подачи заявления<br/>
                Статус<br/>
                <hr/>
                получаем второй файл с конкурсными
                группами, куда абитуриенты подавали заявление
              </v-col>
              <v-col>
                <img
                  :src="
                    $model.wwwroot +
                    '/blocks/manage_groups/admission/img/2.png'
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                3. В ProCollege в разделе Приемная комиссия-> импорт Е-Услуги
                выберите оба файла одновременно(удерживая ctrl)
              </v-col>
              <v-col>
                <img
                  :src="
                    $model.wwwroot +
                    '/blocks/manage_groups/admission/img/3.png'
                  "
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <p>
              Внимание!<br />
              функция экспериментальная, проверяйте достоверность данных при
              импорте.<br />
              Например, СНИЛС абитуриента в настоящее время не переносится, т.к.
              отсутствует в заявлении Е-Услуг
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <v-file-input
        variant="underlined"
        :rules="[
          (v) =>
            (v && v.length == 2) || 'Необходимо загрузить 2 файла одновременно',
        ]"
        accept=".xls"
        chips
        multiple
        label="Загрузите файлы"
        @update:modelValue="addExcelFile($event)"
      ></v-file-input>

      <div style="height: 600px; overflow: auto">
        <p v-for="item in messages" :key="item" v-html="item"></p>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "importEService",
  data() {
    return {
      dialog: false,
      overlay: false,
      messages: [],
    };
  },
  created() {
    /*
    this.axios
      .post(
        this.$root.model.wwwroot +
          "/blocks/manage_groups/index.php/admission/importApplicants",
        null,
        {
          headers: {
            Accept: "application/json",
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      )
      .then((resp) => {
        this.methodName = resp.data;
      })
      .catch((reject) => {});
    */
  },
  methods: {
    addExcelFile(files) {
      if (files.length != 2) return;

      let formData = new FormData();
      for (let file of files) {
        formData.append("files[]", file, file.name);
      }
      this.messages = [];
      this.overlay = true;
      this.axios
        .post(
          this.$model.wwwroot +
            "/procollege/manage_groups/admission/importEService/ImportEServiceUploadFile",
          formData, 
        )
        .then((response) => {
          if(response.data.messages != undefined){
            this.messages = response.data.messages;
          }
          
          this.overlay = false;
        })
        .catch((error) => {
          this.messages = [error.message];
          this.overlay = false;
          console.log( error );
        });
    },
  },
};
</script>
